import script from "./LockModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LockModal.vue?vue&type=script&lang=ts&setup=true"

import "./LockModal.vue?vue&type=style&index=0&id=74c7090c&lang=scss"

const __exports__ = script;

export default __exports__